import { type Component } from 'vue';
import { type RouteRecordRaw, type RouteLocationRaw } from 'vue-router';

import { type ModuleLink } from '.';

export const injectRoutes = (
  mainRoute: RouteRecordRaw,
  sidebar?: {
    modules?: ModuleLink[];
    actions?: Component[];
    user?: {
      status?: Component;
      menu?: Component[];
    };
  },
  layout?: 'old' | 'new' | 'storybook',
) => {
  const redirect: RouteLocationRaw = mainRoute.name ? { name: mainRoute.name } : mainRoute.path;
  return {
    path: '',
    name: 'home',
    meta: {
      modules: sidebar?.modules,
      userStatus: sidebar?.user?.status,
      userMenu: sidebar?.user?.menu,
      sidebarActions: sidebar?.actions,
      redirectUnauthorized: redirect,
    },
    component: () => {
      if (layout === 'storybook') {
        return import('@bv/layouts/main/storybook/MainLayoutShell.vue');
      }
      return import('@bv/layouts/LayoutWrapper.vue');
    },
    redirect,
    children: [
      mainRoute,
      {
        path: ':pathMatch(.*)*',
        name: 'not-found',
        component: () => import('@bv/pages/not-found/NotFound.vue'),
      },
    ],
  } as RouteRecordRaw;
};
